import axios from 'axios';


const getProjectDistribution = async () => {
    const response = await axios.post('/api/v2-app/get-v2-app-distribution');
    return response.data;
}

const getAppTemplates = async(platform) =>{
    const response = await axios.get(`/api/v2-app/get-templates?platform=${platform}`);
    return response.data;
}

const deactivateAppTemplate = async(templateId) =>{
    const response = await axios.post('/api/v2-app/deactivate-app-template',{templateId})
    return response.data;
}

const publishAppTemplate = async(templateId) =>{
    const response = await axios.post('/api/v2-app/publish-app-template',{templateId})
    return response.data;
}

const createAppTemplate = async(formdata) =>{
    const response=await axios.post('/api/v2-app/create-app-template',formdata);
    return response.data;
}

const getV2AppConfigSchema = async(platform) =>{
    const response = await axios.get(`/api/v2-app/v2-app-config-schema?platform=${platform}`);
    return response.data;
}

const getAppSavedConfig = async(templateId) =>{
    let data = {templateId:templateId}
    const response = await axios.post('/api/v2-app/template-saved-config',data);
    return response.data;
}

const storeAppConfig = async(templateId,config_type,config,platform) =>{
    let data = {templateId:templateId,groupName:config_type,formdata:config,platform:platform}
    const response = await axios.post('/api/v2-app/store-template-config',data);
    return response.data;
}

const saveNewTemplateConfig = async(config_type,config,formdetails) => {
    let data = {groupName:config_type,formdata:{...config,formdetails: formdetails || {}}}
    const response = await axios.post('/api/v2-app/save-template-config',data);
    return response.data;
}

const getV2Resources = async (payload) => { // payload can be { config_id } or { projectId, version, config }
    const response = await axios.post('/api/v2-app/get-resources', payload);
    return response.data;
};


export default {
   
    getProjectDistribution,
    getAppTemplates,
    deactivateAppTemplate,
    publishAppTemplate,
    createAppTemplate,
    getV2AppConfigSchema,
    getAppSavedConfig,
    storeAppConfig,
    saveNewTemplateConfig,
    getV2Resources
}